"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleTTSLanguage = void 0;
var GoogleTTSLanguage;
(function (GoogleTTSLanguage) {
    GoogleTTSLanguage["Arabic_Standard_A_Female"] = "ar-XA-Standard-A";
    GoogleTTSLanguage["Arabic_Standard_B_Male"] = "ar-XA-Standard-B";
    GoogleTTSLanguage["Arabic_Standard_C_Male"] = "ar-XA-Standard-C";
    GoogleTTSLanguage["Arabic_Standard_D_Female"] = "ar-XA-Standard-D";
    GoogleTTSLanguage["Arabic_Wavenet_A_Female"] = "ar-XA-Wavenet-A";
    GoogleTTSLanguage["Arabic_Wavenet_B_Male"] = "ar-XA-Wavenet-B";
    GoogleTTSLanguage["Arabic_Wavenet_C_Male"] = "ar-XA-Wavenet-C";
    GoogleTTSLanguage["Czech_Standard_A_Female"] = "cs-CZ-Standard-A";
    GoogleTTSLanguage["Czech_Wavenet_A_Female"] = "cs-CZ-Wavenet-A";
    GoogleTTSLanguage["Danish_Standard_A_Female"] = "da-DK-Standard-A";
    GoogleTTSLanguage["Danish_Wavenet_A_Female"] = "da-DK-Wavenet-A";
    GoogleTTSLanguage["Dutch_Standard_A_Female"] = "nl-NL-Standard-A";
    GoogleTTSLanguage["Dutch_Standard_B_Male"] = "nl-NL-Standard-B";
    GoogleTTSLanguage["Dutch_Standard_C_Male"] = "nl-NL-Standard-C";
    GoogleTTSLanguage["Dutch_Standard_D_Female"] = "nl-NL-Standard-D";
    GoogleTTSLanguage["Dutch_Standard_E_Female"] = "nl-NL-Standard-E";
    GoogleTTSLanguage["Dutch_Wavenet_A_Female"] = "nl-NL-Wavenet-A";
    GoogleTTSLanguage["Dutch_Wavenet_B_Male"] = "nl-NL-Wavenet-B";
    GoogleTTSLanguage["Dutch_Wavenet_C_Male"] = "nl-NL-Wavenet-C";
    GoogleTTSLanguage["Dutch_Wavenet_D_Female"] = "nl-NL-Wavenet-D";
    GoogleTTSLanguage["Dutch_Wavenet_E_Female"] = "nl-NL-Wavenet-E";
    GoogleTTSLanguage["English_AU_Standard_A_Female"] = "en-AU-Standard-A";
    GoogleTTSLanguage["English_AU_Standard_B_Male"] = "en-AU-Standard-B";
    GoogleTTSLanguage["English_AU_Standard_C_Female"] = "en-AU-Standard-C";
    GoogleTTSLanguage["English_AU_Standard_D_Male"] = "en-AU-Standard-D";
    GoogleTTSLanguage["English_AU_Wavenet_A_Female"] = "en-AU-Wavenet-A";
    GoogleTTSLanguage["English_AU_Wavenet_B_Male"] = "en-AU-Wavenet-B";
    GoogleTTSLanguage["English_AU_Wavenet_C_Female"] = "en-AU-Wavenet-C";
    GoogleTTSLanguage["English_AU_Wavenet_D_Male"] = "en-AU-Wavenet-D";
    GoogleTTSLanguage["English_India_Standard_A_Female"] = "en-IN-Standard-A";
    GoogleTTSLanguage["English_India_Standard_B_Male"] = "en-IN-Standard-B";
    GoogleTTSLanguage["English_India_Standard_C_Male"] = "en-IN-Standard-C";
    GoogleTTSLanguage["English_India_Standard_D_Female"] = "en-IN-Standard-D";
    GoogleTTSLanguage["English_India_Wavenet_A_Female"] = "en-IN-Wavenet-A";
    GoogleTTSLanguage["English_India_Wavenet_B_Male"] = "en-IN-Wavenet-B";
    GoogleTTSLanguage["English_India_Wavenet_C_Male"] = "en-IN-Wavenet-C";
    GoogleTTSLanguage["English_India_Wavenet_D_Female"] = "en-IN-Wavenet-D";
    GoogleTTSLanguage["English_UK_Standard_A_Female"] = "en-GB-Standard-A";
    GoogleTTSLanguage["English_UK_Standard_B_Male"] = "en-GB-Standard-B";
    GoogleTTSLanguage["English_UK_Standard_C_Female"] = "en-GB-Standard-C";
    GoogleTTSLanguage["English_UK_Standard_D_Male"] = "en-GB-Standard-D";
    GoogleTTSLanguage["English_UK_Wavenet_A_Female"] = "en-GB-Wavenet-A";
    GoogleTTSLanguage["English_UK_Wavenet_B_Male"] = "en-GB-Wavenet-B";
    GoogleTTSLanguage["English_UK_Wavenet_C_Female"] = "en-GB-Wavenet-C";
    GoogleTTSLanguage["English_UK_Wavenet_D_Male"] = "en-GB-Wavenet-D";
    GoogleTTSLanguage["English_US_Standard_B_Male"] = "en-US-Standard-B";
    GoogleTTSLanguage["English_US_Standard_C_Female"] = "en-US-Standard-C";
    GoogleTTSLanguage["English_US_Standard_D_Male"] = "en-US-Standard-D";
    GoogleTTSLanguage["English_US_Standard_E_Male"] = "en-US-Standard-E";
    GoogleTTSLanguage["English_US_Wavenet_A_Male"] = "en-US-Wavenet-A";
    GoogleTTSLanguage["English_US_Wavenet_B_Male"] = "en-US-Wavenet-B";
    GoogleTTSLanguage["English_US_Wavenet_C_Female"] = "en-US-Wavenet-C";
    GoogleTTSLanguage["English_US_Wavenet_D_Male"] = "en-US-Wavenet-D";
    GoogleTTSLanguage["English_US_Wavenet_E_Female"] = "en-US-Wavenet-E";
    GoogleTTSLanguage["English_US_Wavenet_F_Female"] = "en-US-Wavenet-F";
    GoogleTTSLanguage["Filipino_PH_Standard_A_Female"] = "fil-PH-Standard-A";
    GoogleTTSLanguage["Filipino_PH_Wavenet_A_Female"] = "fil-PH-Wavenet-A";
    GoogleTTSLanguage["Finnish_FI_Standard_A_Female"] = "fi-FI-Standard-A";
    GoogleTTSLanguage["Finnish_FI_Wavenet_A_Female"] = "fi-FI-Wavenet-A";
    GoogleTTSLanguage["French_CA_Standard_A_Female"] = "fr-CA-Standard-A";
    GoogleTTSLanguage["French_CA_Standard_B_Male"] = "fr-CA-Standard-B";
    GoogleTTSLanguage["French_CA_Standard_C_Female"] = "fr-CA-Standard-C";
    GoogleTTSLanguage["French_CA_Standard_D_Male"] = "fr-CA-Standard-D";
    GoogleTTSLanguage["French_CA_Wavenet_A_Female"] = "fr-CA-Wavenet-A";
    GoogleTTSLanguage["French_CA_Wavenet_B_Male"] = "fr-CA-Wavenet-B";
    GoogleTTSLanguage["French_CA_Wavenet_C_Female"] = "fr-CA-Wavenet-C";
    GoogleTTSLanguage["French_CA_Wavenet_D_Male"] = "fr-CA-Wavenet-D";
    GoogleTTSLanguage["French_FR_Standard_A_Female"] = "fr-FR-Standard-A";
    GoogleTTSLanguage["French_FR_Standard_B_Male"] = "fr-FR-Standard-B";
    GoogleTTSLanguage["French_FR_Standard_C_Female"] = "fr-FR-Standard-C";
    GoogleTTSLanguage["French_FR_Standard_D_Male"] = "fr-FR-Standard-D";
    GoogleTTSLanguage["French_FR_Standard_E_Female"] = "fr-FR-Standard-E";
    GoogleTTSLanguage["French_FR_Wavenet_A_Female"] = "fr-FR-Wavenet-A";
    GoogleTTSLanguage["French_FR_Wavenet_B_Male"] = "fr-FR-Wavenet-B";
    GoogleTTSLanguage["French_FR_Wavenet_C_Female"] = "fr-FR-Wavenet-C";
    GoogleTTSLanguage["French_FR_Wavenet_D_Male"] = "fr-FR-Wavenet-D";
    GoogleTTSLanguage["French_FR_Wavenet_E_Female"] = "fr-FR-Wavenet-E";
    GoogleTTSLanguage["German_DE_Standard_A_Female"] = "de-DE-Standard-A";
    GoogleTTSLanguage["German_DE_Standard_B_Male"] = "de-DE-Standard-B";
    GoogleTTSLanguage["German_DE_Standard_E_Male"] = "de-DE-Standard-C";
    GoogleTTSLanguage["German_DE_Standard_F_Female"] = "de-DE-Standard-D";
    GoogleTTSLanguage["German_DE_Wavenet_A_Female"] = "de-DE-Wavenet-A";
    GoogleTTSLanguage["German_DE_Wavenet_B_Male"] = "de-DE-Wavenet-B";
    GoogleTTSLanguage["German_DE_Wavenet_C_Female"] = "de-DE-Wavenet-C";
    GoogleTTSLanguage["German_DE_Wavenet_D_Male"] = "de-DE-Wavenet-D";
    GoogleTTSLanguage["German_DE_Wavenet_E_Male"] = "de-DE-Wavenet-E";
    GoogleTTSLanguage["German_DE_Wavenet_F_Female"] = "de-DE-Wavenet-F";
    GoogleTTSLanguage["Greek_GR_Standard_A_Female"] = "el-GR-Standard-A";
    GoogleTTSLanguage["Greek_GR_Wavenet_A_Female"] = "el-GR-Wavenet-A";
    GoogleTTSLanguage["Hindi_India_Standard_A_Female"] = "hi-IN-Standard-A";
    GoogleTTSLanguage["Hindi_India_Standard_B_Male"] = "hi-IN-Standard-B";
    GoogleTTSLanguage["Hindi_India_Standard_C_Male"] = "hi-IN-Standard-C";
    GoogleTTSLanguage["Hindi_India_Standard_D_Female"] = "hi-IN-Standard-D";
    GoogleTTSLanguage["Hindi_India_Wavenet_A_Female"] = "hi-IN-Wavenet-A";
    GoogleTTSLanguage["Hindi_India_Wavenet_B_Male"] = "hi-IN-Wavenet-B";
    GoogleTTSLanguage["Hindi_India_Wavenet_C_Male"] = "hi-IN-Wavenet-C";
    GoogleTTSLanguage["Hindi_India_Wavenet_D_Female"] = "hi-IN-Wavenet-D";
    GoogleTTSLanguage["Hungarian_HU_Standard_A_Female"] = "hu-HU-Standard-A";
    GoogleTTSLanguage["Hungarian_HU_Wavenet_A_Female"] = "hu-HU-Wavenet-A";
    GoogleTTSLanguage["Indonesian_ID_Standard_A_Female"] = "id-ID-Standard-A";
    GoogleTTSLanguage["Indonesian_ID_Standard_B_Male"] = "id-ID-Standard-B";
    GoogleTTSLanguage["Indonesian_ID_Standard_C_Male"] = "id-ID-Standard-C";
    GoogleTTSLanguage["Indonesian_ID_Standard_D_Female"] = "id-ID-Standard-D";
    GoogleTTSLanguage["Indonesian_ID_Wavenet_A_Female"] = "id-ID-Wavenet-A";
    GoogleTTSLanguage["Indonesian_ID_Wavenet_B_Male"] = "id-ID-Wavenet-B";
    GoogleTTSLanguage["Indonesian_ID_Wavenet_C_Male"] = "id-ID-Wavenet-C";
    GoogleTTSLanguage["Indonesian_ID_Wavenet_D_Female"] = "id-ID-Wavenet-D";
    GoogleTTSLanguage["Italian_IT_Standard_A_Female"] = "it-IT-Standard-A";
    GoogleTTSLanguage["Italian_IT_Standard_B_Female"] = "it-IT-Standard-B";
    GoogleTTSLanguage["Italian_IT_Standard_C_Male"] = "it-IT-Standard-C";
    GoogleTTSLanguage["Italian_IT_Standard_D_Male"] = "it-IT-Standard-D";
    GoogleTTSLanguage["Italian_IT_Wavenet_A_Female"] = "it-IT-Wavenet-A";
    GoogleTTSLanguage["Italian_IT_Wavenet_B_Female"] = "it-IT-Wavenet-B";
    GoogleTTSLanguage["Italian_IT_Wavenet_C_Male"] = "it-IT-Wavenet-C";
    GoogleTTSLanguage["Italian_IT_Wavenet_D_Male"] = "it-IT-Wavenet-D";
    GoogleTTSLanguage["Japanese_JP_Standard_A_Female"] = "js-JP-Standard-A";
    GoogleTTSLanguage["Japanese_JP_Standard_B_Female"] = "js-JP-Standard-B";
    GoogleTTSLanguage["Japanese_JP_Standard_C_Male"] = "js-JP-Standard-C";
    GoogleTTSLanguage["Japanese_JP_Standard_D_Male"] = "js-JP-Standard-D";
    GoogleTTSLanguage["Japanese_JP_Wavenet_A_Female"] = "js-JP-Wavenet-A";
    GoogleTTSLanguage["Japanese_JP_Wavenet_B_Female"] = "js-JP-Wavenet-B";
    GoogleTTSLanguage["Japanese_JP_Wavenet_C_Male"] = "js-JP-Wavenet-C";
    GoogleTTSLanguage["Japanese_JP_Wavenet_D_Male"] = "js-JP-Wavenet-D";
    GoogleTTSLanguage["Korean_KR_Standard_A_Female"] = "ko-KR-Standard-A";
    GoogleTTSLanguage["Korean_KR_Standard_B_Female"] = "ko-KR-Standard-B";
    GoogleTTSLanguage["Korean_KR_Standard_C_Male"] = "ko-KR-Standard-C";
    GoogleTTSLanguage["Korean_KR_Standard_D_Male"] = "ko-KR-Standard-D";
    GoogleTTSLanguage["Korean_KR_Wavenet_A_Female"] = "ko-KR-Wavenet-A";
    GoogleTTSLanguage["Korean_KR_Wavenet_B_Female"] = "ko-KR-Wavenet-B";
    GoogleTTSLanguage["Korean_KR_Wavenet_C_Male"] = "ko-KR-Wavenet-C";
    GoogleTTSLanguage["Korean_KR_Wavenet_D_Male"] = "ko-KR-Wavenet-D";
    GoogleTTSLanguage["Mandarin_CN_Standard_A_Female"] = "cmn-CN-Standard-A";
    GoogleTTSLanguage["Mandarin_CN_Standard_B_Male"] = "cmn-CN-Standard-B";
    GoogleTTSLanguage["Mandarin_CN_Standard_C_Male"] = "cmn-CN-Standard-C";
    GoogleTTSLanguage["Mandarin_CN_Standard_D_Female"] = "cmn-CN-Standard-D";
    GoogleTTSLanguage["Mandarin_CN_Wavenet_A_Female"] = "cmn-CN-Wavenet-A";
    GoogleTTSLanguage["Mandarin_CN_Wavenet_B_Male"] = "cmn-CN-Wavenet-B";
    GoogleTTSLanguage["Mandarin_CN_Wavenet_C_Male"] = "cmn-CN-Wavenet-C";
    GoogleTTSLanguage["Mandarin_CN_Wavenet_D_Female"] = "cmn-CN-Wavenet-D";
    GoogleTTSLanguage["Mandarin_TW_Standard_A_Alpha"] = "cmn-TW-Standard-A-Alpha";
    GoogleTTSLanguage["Mandarin_TW_Standard_B_Alpha"] = "cmn-TW-Standard-B-Alpha";
    GoogleTTSLanguage["Mandarin_TW_Standard_C_Alpha"] = "cmn-TW-Standard-C-Alpha";
    GoogleTTSLanguage["Mandarin_TW_Wavenet_A_Alpha"] = "cmn-TW-Wavenet-A-Alpha";
    GoogleTTSLanguage["Mandarin_TW_Wavenet_B_Alpha"] = "cmn-TW-Wavenet-B-Alpha";
    GoogleTTSLanguage["Mandarin_TW_Wavenet_C_Alpha"] = "cmn-TW-Wavenet-C-Alpha";
    GoogleTTSLanguage["Norwegian_NO_Standard_A_Female"] = "nb-NO-Standard-A";
    GoogleTTSLanguage["Norwegian_NO_Standard_B_Male"] = "nb-NO-Standard-B";
    GoogleTTSLanguage["Norwegian_NO_Standard_C_Female"] = "nb-NO-Standard-C";
    GoogleTTSLanguage["Norwegian_NO_Standard_D_Male"] = "nb-NO-Standard-D";
    GoogleTTSLanguage["Norwegian_NO_Wavenet_A_Female"] = "nb-NO-Wavenet-A";
    GoogleTTSLanguage["Norwegian_NO_Wavenet_B_Male"] = "nb-NO-Wavenet-B";
    GoogleTTSLanguage["Norwegian_NO_Wavenet_C_Female"] = "nb-NO-Wavenet-C";
    GoogleTTSLanguage["Norwegian_NO_Wavenet_D_Male"] = "nb-NO-Wavenet-D";
    GoogleTTSLanguage["Polish_PL_Standard_A_Female"] = "pl=PL-Standard-A";
    GoogleTTSLanguage["Polish_PL_Standard_B_Male"] = "pl=PL-Standard-B";
    GoogleTTSLanguage["Polish_PL_Standard_C_Male"] = "pl=PL-Standard-C";
    GoogleTTSLanguage["Polish_PL_Standard_D_Female"] = "pl=PL-Standard-D";
    GoogleTTSLanguage["Polish_PL_Standard_E_Female"] = "pl=PL-Standard-E";
    GoogleTTSLanguage["Polish_PL_Wavenet_A_Female"] = "pl=PL-Wavenet-A";
    GoogleTTSLanguage["Polish_PL_Wavenet_B_Male"] = "pl=PL-Wavenet-B";
    GoogleTTSLanguage["Polish_PL_Wavenet_C_Male"] = "pl=PL-Wavenet-C";
    GoogleTTSLanguage["Polish_PL_Wavenet_D_Female"] = "pl=PL-Wavenet-D";
    GoogleTTSLanguage["Polish_PL_Wavenet_E_Female"] = "pl=PL-Wavenet-E";
    GoogleTTSLanguage["Portuguese_BR_Standard_A_Female"] = "pt-BR-Standard-A";
    GoogleTTSLanguage["Portuguese_BR_Wavenet_A_Female"] = "pt-BR-Wavenet-A";
    GoogleTTSLanguage["Portuguese_PT_Standard_A_Female"] = "pt-PT-Standard-A";
    GoogleTTSLanguage["Portuguese_PT_Standard_B_Male"] = "pt-PT-Standard-B";
    GoogleTTSLanguage["Portuguese_PT_Standard_C_Male"] = "pt-PT-Standard-C";
    GoogleTTSLanguage["Portuguese_PT_Standard_D_Female"] = "pt-PT-Standard-D";
    GoogleTTSLanguage["Portuguese_PT_Wavenet_A_Female"] = "pt-PT-Wavenet-A";
    GoogleTTSLanguage["Portuguese_PT_Wavenet_B_Male"] = "pt-PT-Wavenet-B";
    GoogleTTSLanguage["Portuguese_PT_Wavenet_C_Male"] = "pt-PT-Wavenet-C";
    GoogleTTSLanguage["Portuguese_PT_Wavenet_D_Female"] = "pt-PT-Wavenet-D";
    GoogleTTSLanguage["Russian_RU_Standard_A_Female"] = "ru-RU-Standard-A";
    GoogleTTSLanguage["Russian_RU_Standard_B_Male"] = "ru-RU-Standard-B";
    GoogleTTSLanguage["Russian_RU_Standard_C_Female"] = "ru-RU-Standard-C";
    GoogleTTSLanguage["Russian_RU_Standard_D_Male"] = "ru-RU-Standard-D";
    GoogleTTSLanguage["Russian_RU_Standard_E_Female"] = "ru-RU-Standard-E";
    GoogleTTSLanguage["Russian_RU_Wavenet_A_Female"] = "ru-RU-Wavenet-A";
    GoogleTTSLanguage["Russian_RU_Wavenet_B_Male"] = "ru-RU-Wavenet-B";
    GoogleTTSLanguage["Russian_RU_Wavenet_C_Female"] = "ru-RU-Wavenet-C";
    GoogleTTSLanguage["Russian_RU_Wavenet_D_Male"] = "ru-RU-Wavenet-D";
    GoogleTTSLanguage["Russian_RU_Wavenet_E_Female"] = "ru-RU-Wavenet-E";
    GoogleTTSLanguage["Slovak_SK_Standard_A_Female"] = "sk-SK-Standard-A";
    GoogleTTSLanguage["Slovak_SK_Wavenet_A_Female"] = "sk-SK-Wavenet-A";
    GoogleTTSLanguage["Spanish_ES_Standard_A_Female"] = "es-ES-Standard-A";
    GoogleTTSLanguage["Swedish_SE_Standard_A_Female"] = "sv-SE-Standard-A";
    GoogleTTSLanguage["Swedish_SE_Wavenet_A_Female"] = "sv-SE-Wavenet-A";
    GoogleTTSLanguage["Turkish_TR_Standard_A_Female"] = "tr-TR-Standard-A";
    GoogleTTSLanguage["Turkish_TR_Standard_B_Male"] = "tr-TR-Standard-B";
    GoogleTTSLanguage["Turkish_TR_Standard_C_Female"] = "tr-TR-Standard-C";
    GoogleTTSLanguage["Turkish_TR_Standard_D_Female"] = "tr-TR-Standard-D";
    GoogleTTSLanguage["Turkish_TR_Standard_E_Male"] = "tr-TR-Standard-E";
    GoogleTTSLanguage["Turkish_TR_Wavenet_A_Female"] = "tr-TR-Wavenet-A";
    GoogleTTSLanguage["Turkish_TR_Wavenet_B_Male"] = "tr-TR-Wavenet-B";
    GoogleTTSLanguage["Turkish_TR_Wavenet_C_Female"] = "tr-TR-Wavenet-C";
    GoogleTTSLanguage["Turkish_TR_Wavenet_D_Female"] = "tr-TR-Wavenet-D";
    GoogleTTSLanguage["Turkish_TR_Wavenet_E_Male"] = "tr-TR-Wavenet-E";
    GoogleTTSLanguage["Ukranian_UA_Standard_A_Female"] = "uk-UA-Standard-A";
    GoogleTTSLanguage["Ukranian_UA_Wavenet_A_Female"] = "uk-UA-Wavenet-A";
    GoogleTTSLanguage["Vietnamese_VN_Standard_A_Female"] = "vi-VN-Standard-A";
    GoogleTTSLanguage["Vietnamese_VN_Standard_B_Male"] = "vi-VN-Standard-B";
    GoogleTTSLanguage["Vietnamese_VN_Standard_C_Female"] = "vi-VN-Standard-C";
    GoogleTTSLanguage["Vietnamese_VN_Standard_D_Male"] = "vi-VN-Standard-D";
    GoogleTTSLanguage["Vietnamese_VN_Wavenet_A_Female"] = "vi-VN-Wavenet-A";
    GoogleTTSLanguage["Vietnamese_VN_Wavenet_B_Male"] = "vi-VN-Wavenet-B";
    GoogleTTSLanguage["Vietnamese_VN_Wavenet_C_Female"] = "vi-VN-Wavenet-C";
    GoogleTTSLanguage["Vietnamese_VN_Wavenet_D_Male"] = "vi-VN-Wavenet-D";
})(GoogleTTSLanguage = exports.GoogleTTSLanguage || (exports.GoogleTTSLanguage = {}));
